// extracted by mini-css-extract-plugin
export default {"statisticRow":"y_ikaggwJSt0ndWBksZR"};